import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import EfScrollAni from '@/efscrollani';
import './index.scss';

interface EfAniStickyProps {
    /**
     * children
     */
    children?: React.ReactNode;
    /**
     * 子元素滚动百分比
     */
    scrollPercent: number[];
    /**
     * 样式名
     */
    className?: string;
}

export const EfAniStickyItem = ({ children, className }: { children?: React.ReactNode; className?: string }) => {
    const prefixCls = `ef-ani-sticky-item`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    return <div className={classes}>{children}</div>;
};
/**
 * 维护:谢保林
 *
 * 单个视频锁屏动画
 */
const EfAniSticky: React.FC<EfAniStickyProps> = ({ className, children, scrollPercent }) => {
    const [activeIndex, setActiveIndex] = useState(1);
    const prefixCls = `ef-ani-sticky`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-active-${activeIndex}`]: activeIndex,
    });
    const refDom = useRef(null);

    useEffect(() => {
        let AniContainer = window.AniContainer;
        if (typeof window !== 'undefined' && !window.AniContainer) {
            AniContainer = new EfScrollAni();
        }
        const sceneEnterA = AniContainer.create({
            triggerElement: refDom.current,
            triggerHook: 0,
            offset: 0,
            duration: '100%', //listH - bodyH,
            onProcess: (process: number) => {
                for (let i = 0; i < scrollPercent.length; i++) {
                    const customA = scrollPercent?.[i - 1] || 0;
                    const customB = scrollPercent?.[i];
                    if (process > customA && process < customB) {
                        setActiveIndex(i + 1);
                    }
                }
            },
        });
    }, []);

    return (
        <div className={classes} ref={refDom}>
            <div className={`${prefixCls}-in`}>
                <div className={`${prefixCls}-box`}>
                    <div className={`${prefixCls}-box-in`}>{children}</div>
                </div>
            </div>
        </div>
    );
};

export default EfAniSticky;
